import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section
      className="bg-neutral-950 text-white"
      data-testid="cta-section"
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-end">
          <div className="md:col-span-8">
            <p className="overline text-neutral-400 mb-6">Let's talk</p>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Have a property that could use a hand?
              <span className="block text-neutral-400 italic">We&rsquo;re a call away.</span>
            </h2>
          </div>
          <div className="md:col-span-4 flex flex-col gap-4">
            <Link
              to="/contact"
              data-testid="cta-request-quote"
              className="inline-flex items-center justify-center bg-white text-black hover:bg-neutral-200 transition-colors px-8 py-5 text-[11px] tracking-[0.22em] uppercase font-medium"
            >
              Request a Quote
            </Link>
            <a
              href="tel:07576639731"
              data-testid="cta-call"
              className="inline-flex items-center justify-center border border-white/40 text-white hover:bg-white hover:text-black transition-colors px-8 py-5 text-[11px] tracking-[0.22em] uppercase font-medium"
            >
              Call 07576 639731
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
